<script setup lang="ts">
const { t } = useTexts();
const { updateWallet, showMoneyFormat } = useWallet();
const { rollover, bonusWallet } = storeToRefs(useWalletStore());
const { closeModal, openToaster } = useLayoutStore();
const { parameters } = useParameters();

const maxBonusWithdrawalMultiply = computed<string>(() => {
  if (!parameters.value?.qtd_withdrawal_bonus) {
    return '1x';
  }

  return `${parameters.value?.qtd_withdrawal_bonus}x`;
});

const isLoading = ref<boolean>(false);

function cancelRequestBonus() {
  closeModal();
}

function requestBonusWithdraw() {
  if (bonusWallet.value.credit <= 0) {
    return;
  }

  const { ApiService } = useApiService();

  isLoading.value = true;

  ApiService.post('/bonus/transfer', {})
    .then((res) => {
      openToaster({
        message: res.data.message,
        type: 'success',
      });
      closeModal();
      updateWallet();
    })
    .catch((err) => {
      const message = err?.data?.message
        ? err?.data?.message
        : err?.message
          ? err?.message
          : t('general.error');

      openToaster({
        message,
        type: 'error',
      });
    })
    .finally(() => {
      isLoading.value = false;
    });
}
</script>

<template>
  <div :class="$style.bonusWithdraw">
    <BaseLoading
      class="!bg-auth-bg-primary"
      :show="isLoading"
    />

    <div :class="$style.infoText">
      <h2>
        {{ $t('account.wallet.bonus_withdraw.attention') }}
      </h2>

      <p>
        {{
          $t('account.wallet.bonus_withdraw.max_bonus_withdraw_amount', {
            bonus_multiplier: maxBonusWithdrawalMultiply,
          })
        }}
      </p>

      <h2>
        {{ $t('account.wallet.bonus_withdraw.bonus_amount') }}
        <br />
        {{
          showMoneyFormat({
            value: (rollover?.max_bonus_withdraw_amount || 0) / 100,
          })
        }}
      </h2>
    </div>

    <p :class="$style.advisorText">
      <span>
        {{ $t('account.wallet.withdraw_modal.withdraw_alert') }}
      </span>
    </p>

    <div :class="$style.confirmationButtons">
      <button
        class="step-actions-btn step-actions-btn-true"
        @click="requestBonusWithdraw()"
      >
        {{ $t('account.wallet.withdraw_modal.confirm') }}
      </button>

      <button
        class="step-actions-btn step-actions-btn-false"
        @click="cancelRequestBonus"
      >
        {{ $t('account.wallet.withdraw_modal.cancel') }}
      </button>
    </div>
  </div>
</template>

<style module lang="postcss">
.bonusWithdraw {
  @apply text-center py-6 px-8 md:py-8 md:px-10;

  .infoText {
    @apply text-warning text-base pt-2 px-10;

    h2 {
      @apply font-bold m-3;
    }

    p {
      @apply m-3;
    }
  }

  .advisorText {
    @apply text-texts leading-6 text-xl font-semibold px-2 py-4 text-center;
  }

  .confirmationButtons {
    @apply grid grid-cols-2 gap-2 py-4;

    button {
      @apply py-2 rounded capitalize;

      &:first-child {
        @apply bg-success text-white;
      }
      &:last-child {
        @apply bg-error text-white;
      }
    }
  }
}
</style>
